"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var isDisplayValueDefined = function isDisplayValueDefined(value) {
  return value !== null && value !== undefined && value !== '';
};

var getOneDisplayValue = function getOneDisplayValue(_ref) {
  var key = _ref.key,
      display = _ref.display,
      language = _ref.language,
      defaultLanguage = _ref.defaultLanguage,
      rootObject = _ref.rootObject;
  var languageDisplayValue = (0, _get["default"])(display, "".concat(language, ".").concat(key), null);

  if (isDisplayValueDefined(languageDisplayValue)) {
    return languageDisplayValue;
  }

  var rootLanguageValue = (0, _get["default"])(rootObject, "".concat(language, ".").concat(key), null);

  if (rootObject && isDisplayValueDefined(rootLanguageValue)) {
    return rootLanguageValue;
  }

  var defaultLanguageDisplayValue = (0, _get["default"])(display, "".concat(defaultLanguage, ".").concat(key), null);

  if (defaultLanguage && isDisplayValueDefined(defaultLanguageDisplayValue)) {
    return defaultLanguageDisplayValue;
  }

  var rootDefaultLanguageValue = (0, _get["default"])(rootObject, "".concat(defaultLanguage, ".").concat(key), null);

  if (defaultLanguage && rootObject && isDisplayValueDefined(rootDefaultLanguageValue)) {
    return rootDefaultLanguageValue;
  }

  var displayValue = (0, _get["default"])(display, key, null);

  if (isDisplayValueDefined(displayValue)) {
    return displayValue;
  }

  var rootValue = (0, _get["default"])(rootObject, key, null);

  if (isDisplayValueDefined(rootValue)) {
    return rootValue;
  }

  return '';
};

var _default = getOneDisplayValue;
exports["default"] = _default;
//# sourceMappingURL=getOneDisplayValue.js.map